import { Button } from "../../../components/button/button";
import { InputNew } from "../../../components/InputNew/InputNew";
import { Loader } from "../../../components/Loader/Loader";
import { Text } from "../../../components/texts/text";
import Title from "../../../components/texts/title";
import {
  _aligeText,
  _colorText,
  _size,
  _sizeHeading,
  _sizeText,
  _typeInput
} from "../../../core/core";
import { useLogin } from "../hooks/useLogin";
import "./LoginForm.css";

export const LoginForm = () => {
  const {
    email,
    setEmail,
    code,
    setCode,
    error,
    isCode,
    isLoading,
    onKeyDownEmail,
    onKeyDownCode,
    handleEmailClick,
    handleCodeClick,
  } = useLogin();

  return (
    <div className="login">
      <div className="login-body">
        <div className="login-header">
          <Title type={_sizeHeading.h2_2} is_h1>
            Вход в аккаунт
          </Title>
          <Text
            size={_sizeText.m}
            aligeText={_aligeText.center}
            color={_colorText.neutral}
          >
            {isCode
              ? `Отправили код на ${email}. Проверьте спам.`
              : "Укажите почту, отправим код подтверждения"}
          </Text>
        </div>
        {isLoading ? (
          <Loader isLoading></Loader>
        ) : (
          <>
            {isCode ? (
              <div className="login-main">
                <InputNew
                  placeholder="Укажите код"
                  error={error}
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  onKeyDown={onKeyDownCode}
                  type={_typeInput.number}
                ></InputNew>
                <Button size={_size.M} width={"100%"} onClick={() => handleCodeClick({ email, code })}>
                  Войти
                </Button>

              </div>
            ) : (
              <div className="login-main">
                <InputNew
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onKeyDown={onKeyDownEmail}
                  placeholder={"Указать почту"}
                ></InputNew>
                <Button size={_size.M} width={"100%"} onClick={handleEmailClick}>
                  Получить код
                </Button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
